import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  notification,
  Radio,
  Row,
  Select,
  TimePicker,
  Switch,
  Popover,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { PayMethod } from '../../../models/payment'
import {
  getTenantCategoryName,
  Tenant,
  TenantCategory,
} from '../../../models/tenant'
import { stringTrim } from '../../../utils/StringUtils'
import { setSettings } from '../../settings/settingsSlice'
import {
  getSettingDetail,
  saveSettingLabel,
  selectNextSendDay,
  selectSettings,
  selectTenant,
  setIsChange,
  setNextSendDay,
} from './settingSlice'
import styles from '../Users.module.css'
import { Amount } from '../../Echarts/insuranceContorl/amount/Amount'
import {
  selectEdition,
  selectInsuranceArray,
} from '../../../app/applicationSlice'
import { Checks, Settinglable, Settings } from '../../../models/setting'
import {
  getAcceptsType,
  getSaveSomeFunctions,
} from '../../registration/register/registerSlice'
import { QuestionCircleTwoTone } from '@ant-design/icons'

export const SettingInsurance = (props: {
  selectedTab?: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const tenant = useSelector(selectTenant)

  const settings = useSelector(selectSettings)

  const nextSendDay = useSelector(selectNextSendDay)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const insuranceArray = useSelector(selectInsuranceArray)

  const [previewPayMethod, setPreviewPayMethod] = useState(PayMethod.Cash)

  const [buttonLoading, setButtonLoading] = useState(false)

  const [values, setValues] = useState<any>()

  const [glReminder, setGlReminder] = useState<any>(false)

  const [sqReminder, setSQReminder] = useState<any>(false)

  const [xyzdxyReminder, setXyzdxyReminder] = useState<any>(false)

  const [defaultAlarmValueList, setDefaultAlarmValueList] = useState<any[]>()

  useEffect(() => {
    if (tenant) {
      form.setFieldsValue({
        ...tenant,
        registeredFund: null,
        // tenantCategory: getTenantCategoryName(tenant.tenantCategory)
      })
    }
    if (settings) {
      const defaultMethod =
        (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
      setPreviewPayMethod(defaultMethod)
      dispatch(
        setSettings({
          [Settings.Treatment.DoNotWarnDoctorMismatch]:
            settings[Checks.Gbkdysstx] || false,
          [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
          [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
          [Settings.Payment.DefautMethod]: defaultMethod,
        })
      )

      const gltx = settings[Checks.KFGLTX]
      setGlReminder(gltx === true || gltx === 'true')

      const sqtx = settings[Checks.YBSQZDTX]
      setSQReminder(sqtx === true || sqtx === 'true')

      const xyzdxy = settings[Checks.ZYBLXYZDXY]
      setXyzdxyReminder(xyzdxy === true || xyzdxy === 'true')

      const value = settings[Checks.Zdrjsj]
      form.setFieldsValue({
        ...settings,
        [Checks.Zdrjsj]:
          value === '' || value === undefined || value === 'Invadlid date'
            ? undefined
            : moment(value, 'HH:mm'),
      })
    }
  }, [tenant, settings])

  useEffect(() => {
    getType57()
    getType130()
    dispatch(getSettingDetail())
  }, [])

  const invoiceLayout = {
    labelCol: {
      span: 8,
    },
  }

  const rules = [
    {
      pattern: new RegExp(/^([0-9]+[\d]*(.[0-9]{1,2})?)$/, 'g'),
      message: '请输入保留小数两位以内的数',
    },
  ]

  const phoneRules = [
    {
      pattern: /^1\d{10}$/,
      message: '请输入正确的手机号',
    },
  ]
  const getType130 = () => {
    dispatch(
      getAcceptsType({
        type: '130',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if(res== '[object Object]'){
          // 不设置默认值
          // form.setFieldsValue({
          //   [Checks.ZSMTXFS]:["1"]
          // })
        }else{
          const resList = res.split(",");
          form.setFieldsValue({
            [Checks.ZSMTXFS]:resList
          })

        }



      })
  }
  const getType57 = () => {
    dispatch(
      getAcceptsType({
        type: '57',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setValues(res == '[object Object]' ? 20 : res)
      })
  }

  return (
    <div
     className={styles.settingInsurance}
    >
      <Row
        style={{
          fontSize: 16,
          fontWeight: 'bold',
          borderBottom: '1px dashed #BBBBBB',
          paddingBottom: '10px',
          width: '90%',
        }}
      >
        追溯码设置
      </Row>
      <Row style={{ paddingLeft: '56px', margin: '20px 0' }}>
        <Col>
          <Form labelAlign='right' form={form} autoComplete='off'>
            <>
              <Col
                style={{
                  marginLeft: '56px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Form.Item label='提醒场景设置：' name={Checks.ZSMTXFS} >
                  <Checkbox.Group>
                    <Checkbox value={'1'}><span>发药时提醒</span><span style={{ fontSize: '12px', color: '#999999' ,marginLeft:'6px'}}>(只作用于手动发药)</span></Checkbox>
                    <Checkbox value={'2'}>收费时提醒</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </>
          </Form>
        </Col>
      </Row>

          {insuranceArray?.length > 0 ? (
        <>
          <Row
            style={{
              fontSize: 16,
              fontWeight: 'bold',
              borderBottom: '1px dashed #BBBBBB',
              paddingBottom: '10px',
              width: '90%',
            }}
          >
            门诊开单
          </Row>
          <Row style={{ paddingLeft: '56px', margin: '20px 0' }}>
            <Col>
              <Form labelAlign='right' form={form} autoComplete='off'>
                <>
                  <Col
                    style={{
                      marginLeft: '56px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Form.Item
                      name={Checks.ZYBLXYZDXY}
                      label='中医病历西医诊断校验：'
                      style={{ marginBottom: 0 }}
                    >
                      <Switch
                        style={{ marginRight: '10px' }}
                        checked={xyzdxyReminder}
                        checkedChildren='开启'
                        unCheckedChildren='关闭'
                        onChange={(v) => {
                          setXyzdxyReminder(v)
                        }}
                      />
                    </Form.Item>
                    <span style={{ fontSize: '12px', color: '#999999' }}>
                      开启后，如果没有填写西医诊断则无法保存病历，并且第一个西医诊断会作为主诊断
                    </span>
                  </Col>
                </>
              </Form>
            </Col>
          </Row>
          {hisVersion == 0 && (
            <Row style={{ paddingLeft: '56px', margin: '20px 0' }}>
            <Col>
              <Form labelAlign='right' form={form} autoComplete='off'>
                <>
                  <Col
                    style={{
                      marginLeft: '24px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <span>中药开方味数提醒：</span>
                    <Input
                      addonAfter='味'
                      style={{ margin: '0 8px', width: '110px' }}
                      value={values}
                      onChange={(v: any) => {
                        setValues(v?.target?.value)
                      }}
                      onBlur={(v) => {
                        setValues(v?.target?.value)
                        const params: any = [
                          { type: '57', value: v?.target?.value || 20 },
                        ]
                        dispatch(getSaveSomeFunctions({ functionList: params }))
                          .then(unwrapResult)
                          .then((res: any) => {
                            getType57()
                          })
                      }}
                    />
                    <span style={{ fontSize: '12px', color: '#999999' }}>
                      医保患者一个中药方默认超出20味会提醒，机构可根据需要修改提醒味数
                    </span>
                  </Col>
                </>
              </Form>
            </Col>
          </Row>
          )}
          <Row style={{ paddingLeft: '56px', margin: '20px 0' }}>
            <Col>
              <Form labelAlign='right' form={form} autoComplete='off'>
                <>
                  <Col
                    style={{
                      marginLeft: '56px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >

                    <Form.Item name={Checks.KFGLTX} label='开方超量提醒：' style={{ marginBottom: 0 }} >
                      <Switch
                        style={{ marginRight: '10px' }}
                        checked={glReminder}
                        checkedChildren='开启'
                        unCheckedChildren='关闭'
                        onChange={(v) => {
                          setGlReminder(v)
                        }}
                      />
                    </Form.Item>
                    <span style={{ fontSize: '12px', color: '#999999' }}>
                      开启后，医保患者开药的天数超过医保规定的天数则提醒&nbsp;
                    </span>
                    <Popover
                      title='详细规则'
                      content={
                        <div>
                          <p>1. <strong>急性病</strong>：开方天数不能超过3天，本次开方天数如果超过3天则添加下来后做提醒。</p>
                          <p>2. <strong>一般疾病</strong>：开方天数不能超过7天，如超过则添加下来后会提醒，和上次开方天数（n天）间隔时间不足（n-3）天也会提醒。</p>
                          <p>3. <strong>一般慢性病</strong>：开方天数不能超过15天，如超过则添加下来后做提醒，和上次开方天数（n天）间隔时间不（n-3）天也会提醒。</p>
                          <p>4. <strong>纳入特殊病种管理的疾病</strong>：开方天数不能超过30天，如超过则添加下来后做提醒，和上次开方天数（n天）间隔时间不足（n-3）天也会提醒。</p>
                          <p>5. <strong>纳入慢性病病症门诊管理的慢性病</strong>：开方天数不能超过90天，如超过则添加下来后做提醒，和上次开方天数（n天）间隔时间不足（n-3）天也会提醒。</p>
                        </div>
                      }>
                      <a>查看详细规则</a>
                    </Popover>
                  </Col>
                </>
              </Form>
            </Col>
          </Row>
          <Row style={{ paddingLeft: '56px', margin: '20px 0' }}>
            <Col>
              <Form labelAlign='right' form={form} autoComplete='off'>
                <>
                  <Col
                    style={{
                      marginLeft: '26px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >

                    <Form.Item name={Checks.YBSQZDTX} label='医保事前自动提醒' style={{ marginBottom: 0 }} >
                      <Switch
                        style={{ marginRight: '10px' }}
                        checked={sqReminder}
                        checkedChildren='开启'
                        unCheckedChildren='关闭'
                        onChange={(v) => {
                          setSQReminder(v)
                        }}
                      />
                    </Form.Item>
                    <span style={{ fontSize: '12px', color: '#999999' }}>
                      开启后，快速开单点击预结算和医生门诊点击诊断完毕或诊间结算时会自动调用医保事前提醒接口，如有问题会弹窗提醒
                    </span>
                  </Col>
                </>
              </Form>
            </Col>
          </Row>
        </>
      ) : (
        <></>
      )}
      {hisVersion == 0 && insuranceArray?.length > 0 ? (
        <>
          <Row
            style={{
              fontSize: 16,
              fontWeight: 'bold',
              borderBottom: '1px dashed #BBBBBB',
              paddingBottom: '10px',
              width: '90%',
            }}
          >
            医保帖均设置
          </Row>
          <Row style={{ paddingLeft: '50px', marginTop: '10px' }}>
            <Col>
              <Amount type={1} />
            </Col>
          </Row>
        </>
      ) : (
        <></>
      )}
      <Row
        style={{
          fontSize: 16,
          fontWeight: 'bold',
          borderBottom: '1px dashed #BBBBBB',
          paddingBottom: '10px',
          width: '90%',
          marginTop:
            hisVersion == 0 && insuranceArray?.length > 0 ? '20px' : '0px',
        }}
      >
        预警线设置
      </Row>
      <Form
        labelAlign='right'
        initialValues={{
          remember: true,
          [Checks.ISEDIT]: '1',
          [Checks.FYFS]: '1',
        }}           
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          if (
            (values[Checks.SJHM] && !values[Checks.TSPL]) ||
            (!values[Checks.SJHM] && values[Checks.TSPL])
          ) {
            notification.error({
              message: '请完善手机号码或推送频率',
            })
            return
          }
          const pattern = /^[0-9]*$/
          const t = _.chain(values)
            .omitBy((_, k) => pattern.test(k))
            .value() as Tenant
          const f = _.chain(values)
            .pickBy((_, k) => pattern.test(k))
            .mapValues(
              (v, k) =>
                ({
                  type: k,
                  value:
                    k === Checks.Zdrjsj.toString()
                      ? moment(v).format('HH:mm:ss')
                      : v?.toString(),
                } as Settinglable)
            )
            .values()
            .value()
          setButtonLoading(true)
          dispatch(
            saveSettingLabel({
              tenant: {
                ...tenant,
                ...t,
              },
              functionList: f,
            })
          )
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: '机构设置保存成功',
                duration: 3,
              })
              dispatch(getSettingDetail())
            })
            .catch(() => {
              notification.error({ message: '机构设置保存失败', duration: 3 })
              dispatch(getSettingDetail())
            })
            .finally(() => {
              dispatch(setIsChange(false))
              setButtonLoading(false)
            })
        }}
        onValuesChange={(values, all) => {
          dispatch(setIsChange(true))
        }}
      >
        <Row style={{ marginTop: '20px' }}>
          <Col style={{ width: '600px' }}>
            <Form.Item
              {...invoiceLayout}
              label='中草药年度帖均额度'
              rules={rules}
              getValueFromEvent={stringTrim}
              name={Checks.ZCYNDJTED}
            >
              <Input addonAfter='元' />
            </Form.Item>
            <Form.Item
              {...invoiceLayout}
              label='医保基金年度支付限额'
              rules={rules}
              getValueFromEvent={stringTrim}
              name={Checks.YBJJNDZFXE}
            >
              <Input addonAfter='元' />
            </Form.Item>
            <Form.Item
              {...invoiceLayout}
              label='医保列支医疗费年度支付限额'
              rules={rules}
              getValueFromEvent={stringTrim}
              name={Checks.YBLZYLFNDZFXE}
            >
              <Input addonAfter='元' />
            </Form.Item>
            <Form.Item
              {...invoiceLayout}
              label='人次人头比'
              rules={rules}
              getValueFromEvent={stringTrim}
              name={Checks.RCRTB}
            >
              <Input addonAfter='%' />
            </Form.Item>
            <Form.Item
              {...invoiceLayout}
              label='次均年度费用限额'
              rules={rules}
              getValueFromEvent={stringTrim}
              name={Checks.CJNDFYXE}
            >
              <Input addonAfter='元' />
            </Form.Item>
            <Form.Item
              {...invoiceLayout}
              label='人均年度费用限额'
              rules={rules}
              getValueFromEvent={stringTrim}
              name={Checks.RJNDFYXE}
            >
              <Input addonAfter='元' />
            </Form.Item>
            <Col style={{position:'relative'}}>
            <Form.Item
                {...invoiceLayout}
                label='职工医保月均限额'
                rules={rules}
                getValueFromEvent={stringTrim}
                name={Checks.INSURANCE310LIMIT}
              >
                <Input addonAfter='元' />
              </Form.Item>
                <Popover placement='top' content={'当前月均：本年 1 月至上月末累计金额除以上月月份数'}>
                    <QuestionCircleTwoTone style={{ fontSize: '18px',position:'absolute',top:'7px',right:'-28px' }} />
                </Popover>
              </Col>
              <Col style={{position:'relative'}}>
              <Form.Item
                {...invoiceLayout}
                label='城乡医保月均限额'
                rules={rules}
                getValueFromEvent={stringTrim}
                name={Checks.INSURANCE390LIMIT}
              >
                <Input addonAfter='元' />
              </Form.Item>
                <Popover placement='top' content={'当前月均：本年 1 月至上月末累计金额除以上月月份数'}>
                    <QuestionCircleTwoTone style={{ fontSize: '18px',position:'absolute',top:'7px',right:'-28px' }} />
                </Popover>
              </Col>
            <Form.Item
              {...invoiceLayout}
              label='手机号码'
              rules={phoneRules}
              getValueFromEvent={stringTrim}
              name={Checks.SJHM}
            >
              <Input maxLength={11} />
            </Form.Item>
            <Form.Item name={Checks.TSPL} className={styles.formItem}>
              <Form.Item
                {...invoiceLayout}
                label='推送频率'
                rules={[
                  {
                    pattern: /^\d+$/,
                    message: '请输入正确数字',
                  },
                ]}
                getValueFromEvent={stringTrim}
                name={Checks.TSPL}
              >
                <Input
                  addonAfter='天/次'
                  onChange={(e) => {
                    const day = moment(new Date())
                      .add(e.target.value, 'days')
                      .format('YYYY/MM/DD')
                    dispatch(setNextSendDay(day))
                  }}
                />
              </Form.Item>
              <span className={styles.span}>下次推送时间：{nextSendDay}</span>
            </Form.Item>
            {/* <Form.Item {...invoiceLayout} label='推送频率' rules={[{
                pattern: /^\d+$/,
                message: "请输入正确的手机号",
              }]} getValueFromEvent={stringTrim} name={Checks.TSPL} >
                <Input addonAfter="天/次" />
              </Form.Item> */}
          </Col>
        </Row>
        <Row style={{ position: 'fixed', bottom: '38px' ,width: '77.5%'}}>
          <Col span={24} style={{ display: 'flex', justifyContent: 'center'  }}>
            <Button
              htmlType='button'
              onClick={() => {
                history.go(-1)
              }}
              style={{
                float: 'right',
                marginRight: '10px',
              }}
            >
              取消
            </Button>
            <Button
              loading={buttonLoading}
              type='primary'
              htmlType='submit'
              style={{
                float: 'left',
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  )
}
